/* import __COLOCATED_TEMPLATE__ from './about.hbs'; */
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class PracticeWebsiteEditMenuAbout extends Component {}
